import env from './env'
import AgAnimal from '@/components/Animal'
import AgAnimalScroller from '@/components/AnimalScroller'
import AgBase from '@/components/Base'
import AgCard from '@/components/Card'
import AgButton from '@/components/Button'
import AgButtonSet from '@/components/ButtonSet'
import AgInput from '@/components/Input'
import AgAvatar from '@/components/Avatar'
import AgIcon from '@/components/Icon'
import AgNotice from '@/components/Notice'
import AgImage from '@/components/Image'
import AgCheckbox from '@/components/Checkbox'
import AgCheckboxGroup from '@/components/CheckboxGroup'
import AgForm from '@/components/Form'
import AgCaption from '@/components/Caption'
import AgList from '@/components/List'
import AgHtml from '@/components/Html'
import AgCollapsible from '@/components/Collapsible'
import Box from '@/components/Web/Box'
import Page from '@/components/Web/Page'
import Frame from '@/components/Web/Frame'
import AbsoluteLayout from '@/components/Web/AbsoluteLayout'
import DockLayout from '@/components/Web/DockLayout'
import FlexboxLayout from '@/components/Web/FlexboxLayout'
import GridLayout from '@/components/Web/GridLayout'
import StackLayout from '@/components/Web/StackLayout'
import WrapLayout from '@/components/Web/WrapLayout'
import Label from '@/components/Web/Label'
import ScrollView from '@/components/Web/ScrollView'
import Button from '@/components/Web/Button'
import TextField from '@/components/Web/TextField'
import ActivityIndicator from '@/components/Web/ActivityIndicator'
import DatePicker from '@/components/Web/DatePicker'
import TextView from '@/components/Web/TextView'
import HtmlView from '@/components/Web/HtmlView'
import WebView from '@/components/Web/WebView'

function registerGlobalComponents (Vue) {
  Vue.component('AgAnimal', AgAnimal)
  Vue.component('AgAnimalScroller', AgAnimalScroller)
  Vue.component('AgBase', AgBase)
  Vue.component('AgCard', AgCard)
  Vue.component('AgButton', AgButton)
  Vue.component('AgButtonSet', AgButtonSet)
  Vue.component('AgInput', AgInput)
  Vue.component('AgAvatar', AgAvatar)
  Vue.component('AgIcon', AgIcon)
  Vue.component('AgNotice', AgNotice)
  Vue.component('AgImage', AgImage)
  Vue.component('AgCheckbox', AgCheckbox)
  Vue.component('AgCheckboxGroup', AgCheckboxGroup)
  Vue.component('AgForm', AgForm)
  Vue.component('AgCaption', AgCaption)
  Vue.component('AgList', AgList)
  Vue.component('AgHtml', AgHtml)
  Vue.component('AgCollapsible', AgCollapsible)

  if (env.isWeb) {
    Vue.component('Box', Box)
    Vue.component('Page', Page)
    Vue.component('Frame', Frame)
    Vue.component('AbsoluteLayout', AbsoluteLayout)
    Vue.component('DockLayout', DockLayout)
    Vue.component('FlexboxLayout', FlexboxLayout)
    Vue.component('GridLayout', GridLayout)
    Vue.component('StackLayout', StackLayout)
    Vue.component('WrapLayout', WrapLayout)
    Vue.component('Label', Label)
    Vue.component('Button', Button)
    Vue.component('TextField', TextField)
    Vue.component('ScrollView', ScrollView)
    Vue.component('ActivityIndicator', ActivityIndicator)
    Vue.component('DatePicker', DatePicker)
    Vue.component('TextView', TextView)
    Vue.component('HtmlView', HtmlView)
    Vue.component('WebView', WebView)
  }
}

export {
  registerGlobalComponents
}